export default __webpack_public_path__ + "static/media/Aravind.b9508c09.png";